export default __webpack_public_path__ + "static/media/cap.ca00df38.webp";